// This file is a legacy file and should not be used in new code. This also uses newer components from the checkout flow.
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import { Waiver } from 'legacy/components/pages/Events/EventForm/Groups/Waiver/EventWaiverModal';
import GuestWaiver from 'features/events/checkout/components/WaiverStep/components/GuestWaiver';
import styles from './ClaimTicketWaiverSection.module.scss';

interface ClaimTicketWaiverSectionProps {
  onGoBack: () => void;
  onClaimTicket: () => void;
  setCheckedWaiverCount: (count: number) => void;
  eventWaiver: {
    isWaiverSet: boolean;
    waiverContent?: string;
    waivers?: Waiver[];
  };
  isEventWaiverAccepted: boolean;
  isLoadingClaimShareToken: boolean;
  isLoadingEventWaiver: boolean;
  checkedWaiverCount: number;
  onShowPrePurchaseQuestions: () => void;
  hasPrePurchaseQuestions: boolean;
}

const ClaimTicketWaiverSection: React.FC<ClaimTicketWaiverSectionProps> = ({
  onGoBack,
  onClaimTicket,
  setCheckedWaiverCount,
  onShowPrePurchaseQuestions,
  hasPrePurchaseQuestions,
  eventWaiver,
  isEventWaiverAccepted,
  isLoadingClaimShareToken,
  isLoadingEventWaiver,
  checkedWaiverCount
}) => (
  <div className="px-8 py-0 bg-white border-1 border-solid border-gray-200 rounded-xl">
    <GuestWaiver
      onGoBack={onGoBack}
      waivers={eventWaiver?.waivers}
      setCheckedWaiverCount={setCheckedWaiverCount}
      headerStyle={styles.headerStyle}
    />
    <div className="border-b-1 border-gray-200 mt-3 pt-3 -ml-11 -mr-11" />
    <div className="my-4">
      {hasPrePurchaseQuestions ? (
        <Button
          disabled={!isEventWaiverAccepted}
          onClick={onShowPrePurchaseQuestions}
          loading={isLoadingClaimShareToken || isLoadingEventWaiver}
          type={ButtonType.Primary}
        >
          Continue to Guest Questions
        </Button>
      ) : (
        <Button
          disabled={!isEventWaiverAccepted}
          onClick={onClaimTicket}
          loading={isLoadingClaimShareToken || isLoadingEventWaiver}
          type={ButtonType.Primary}
        >
          {`Claim Ticket ${checkedWaiverCount}/${eventWaiver?.waivers?.length} `}
        </Button>
      )}
    </div>
  </div>
);

export default ClaimTicketWaiverSection;
